export const getCategory = (category, rels) => {
  return rels.filter((rel) => rel.uuid === category)[0];
};
